import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { formValueSelector, change } from 'redux-form';
import { push } from 'connected-react-router';
import { number, shape, bool, string } from 'prop-types';

import { ROUTES } from 'constants/routes';

import SecondaryTopbar from '../../../../components/SecondaryTopbar';
import { actionCreators as accountActionCreators } from '../../../../../redux/accountHandlers';
import { message } from '../../../../../utils/stringUtils';
import { CHANGE_EXPIRATION_DATE } from '../../../../../constants/reduxForms';
import WithoutAccounts from '../../../../components/WithoutAccounts';
import { gaTrackPageView } from '../../../../../services/AnalyticsService';

import ChangeDueDate from './layout';
import { START_DAY, END_DAY } from './constants';
import styles from './styles';

class ChangeDueDateContainer extends PureComponent {
  state = { prevStart: 0, prevEnd: 0, initialValues: { [START_DAY]: 1, [END_DAY]: 5 } };

  componentDidMount = () => {
    this.props.dispatch(accountActionCreators.evaluateChangeExpirationDate());
    gaTrackPageView(ROUTES.CHANGE_DUE_DATE);
  };

  componentDidUpdate = prevProps => {
    if (
      prevProps.evaluateChangeExpDate !== this.props.evaluateChangeExpDate &&
      this.props.evaluateChangeExpDate &&
      !this.props.evaluateChangeExpDate.can_view
    )
      this.props.dispatch(push(ROUTES.ACCOUNT_STATUS));
    if (
      this.props.evaluateChangeExpDate &&
      prevProps.evaluateChangeExpDate !== this.props.evaluateChangeExpDate
    ) {
      this.props.dispatch(
        change(CHANGE_EXPIRATION_DATE, START_DAY, this.props.evaluateChangeExpDate.expiration_start_day)
      );
      this.props.dispatch(
        change(CHANGE_EXPIRATION_DATE, END_DAY, this.props.evaluateChangeExpDate.expiration_end_day)
      );
    }
  };

  handleInitChange = value => {
    this.setState({ prevStart: value.min, prevEnd: value.max });
  };

  handleChangeSlider = value => {
    if (value.min === this.state.prevStart && value.max - value.min > 4) value.min = value.max - 4;
    if (value.max === this.state.prevEnd && value.max - value.min > 4) value.max = value.min + 4;
    this.setState({ prevStart: value.min, prevEnd: value.max }, () => {
      this.props.dispatch(change(CHANGE_EXPIRATION_DATE, START_DAY, value.min));
      this.props.dispatch(change(CHANGE_EXPIRATION_DATE, END_DAY, value.max));
    });
  };

  handleChangeExpirationDays = () => {
    this.props.dispatch(accountActionCreators.changeExpirationDate(this.props.startDay, this.props.endDay));
  };

  render() {
    return (
      <div style={styles.container}>
        <SecondaryTopbar titleText={message('ChangeDueDate:title')} />
        <ChangeDueDate
          startDay={this.props.startDay}
          endDay={this.props.endDay}
          canChange={this.props.evaluateChangeExpDate && this.props.evaluateChangeExpDate.can_change}
          canView={this.props.evaluateChangeExpDate && this.props.evaluateChangeExpDate.can_view}
          loading={this.props.evaluateChangeExpDateLoading || this.props.changeExpirationDateLoading}
          onChangeSlider={this.handleChangeSlider}
          onInitChange={this.handleInitChange}
          onChangeExpirationDays={this.handleChangeExpirationDays}
          initialValues={this.state.initialValues}
          mssg={this.props.evaluateChangeExpDate && this.props.evaluateChangeExpDate.message}
        />
      </div>
    );
  }
}

ChangeDueDateContainer.propTypes = {
  evaluateChangeExpDate: shape({
    can_view: bool,
    can_change: bool,
    expiration_start_day: number,
    expiration_end_day: number,
    message: string
  }),
  evaluateChangeExpDateLoading: bool,
  changeExpirationDateLoading: bool,
  startDay: number,
  endDay: number
};

const formSelector = formValueSelector(CHANGE_EXPIRATION_DATE);

const mapStateToProps = store => ({
  startDay: formSelector(store, START_DAY),
  endDay: formSelector(store, END_DAY),
  evaluateChangeExpDate: store.account.evaluateChangeExpDate,
  evaluateChangeExpDateLoading: store.account.evaluateChangeExpDateLoading,
  changeExpirationDate: store.account.changeExpirationDate,
  changeExpirationDateLoading: store.account.changeExpirationDateLoading,
  accounts: store.account.accounts,
  accountsLoading: store.account.accountsLoading,
  accountsError: store.account.accountsError
});

export default connect(mapStateToProps)(
  WithoutAccounts({
    shouldShowMessage: props => props.accounts.length === 0 && !props.accountsLoading,
    accountsError: props => props.accountsError
  })(ChangeDueDateContainer)
);
